// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import CategoryIcon from '@mui/icons-material/Category';
import moment from 'moment';

const PassengersGroupsTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="PassengersGroups"
      pageIcon={CategoryIcon}
      addButtonLabel="AddNewPassengersGroup"

      // ============ NAVIGATION URLs ============
      addPageUrl="/fare-products/passengers-groups/new"
      viewPageUrl="/fare-products/passengers-groups/:id"
      editPageUrl="/fare-products/passengers-groups/:id/edit?came_from=all"

      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups`}
      getApiMethod="GET"

      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups/:id`}
      deleteApiMethod="DELETE"

      // ============ RESPONSE CONFIGURATION ============
      // Typo in backend response: fareMedaiGroups instead of passengersGroups
      responseDataPath="data.data.passengersGroups"
      responsePaginationPath="data.data.pagination"

      // ============ TABLE CONFIGURATION ============
      idField="passengers_groups_id"
      columns={[
        {
          field: 'name',
          headerKey: 'GroupName',
          align: 'center',
          sortable: true,
          sortField: currentLanguageCode === 'en-us' ? 'pg.en_name' : 'pg.name',
          render: (value, row) => currentLanguageCode === 'en-us' ? row.en_name : row.name,
        },
        {
          field: 'description',
          headerKey: 'description',
          align: 'center',
          sortable: true,
          sortField: 'pg.description',
        },
        {
          field: 'org_en_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.org_en_name : row.org_ar_name
          ),
        },
        {
          field: 'is_default',
          headerKey: 'IsDefault',
          align: 'center',
          render: (value, row) => (row.is_default ? '✓' : '-'),
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
          sortable: true,
          sortField: 'pg.created_at',
        },
      ]}

      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchPassengersGroupPlaceholder"
      searchInputWidth="260px"

      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'organisations_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
      ]}

      // ============ PERMISSIONS ============
      subsystemName="PassengersGroups"
      permissionSystem="fares"

      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeletePassengersGroup"
    />
  );
};

export default PassengersGroupsTable;
